import { render, staticRenderFns } from "./LiveEventsVerticalScroller.vue?vue&type=template&id=3e51c950"
import script from "./LiveEventsVerticalScroller.vue?vue&type=script&lang=js"
export * from "./LiveEventsVerticalScroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports